export const ActionTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    SET_USER: 'SET_USER',
    SET_USER_ROLE: 'SET_USER_ROLE',
};

export const initialState = {
    user: null,
    userToken: null,
    isAuthenticated: false,
    userRole: [],
};

// Rename to avoid confusion with the main appReducer
export function reducer(state, action) {
  switch (action.type) {
    case ActionTypes.LOGIN:
      return {
        ...state,
        userToken: action.payload.userToken,
        isAuthenticated: true,
      };
    case ActionTypes.LOGOUT:
      return {
        ...state,
        userToken: null,
        isAuthenticated: false,
      };
    case ActionTypes.SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case ActionTypes.SET_USER_ROLE:
      return {
        ...state,
        userRole: action.payload,
      };
    default:
      return state;
  }
}